import { PROGRESS } from 'config/config';
import { getContainerHeight } from 'helpers/commonHelper';
import React, { createRef, PureComponent, RefObject } from 'react';

import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { IGooglePayConfigurationContext } from 'types/GooglePayConfigurationContext';
import { getGooglePayConfiguration } from 'services/Api';
import GPayDetailsContainer from './Gpay.styles';
import withGooglePayConfigurationContext from '../../hoc/WithGooglePayConfigurationContext';
import withContext from '../../hoc/withContext';
import withTextContext from '../../hoc/withTextContext';

interface IProps extends IAccordionWrapper, IContext, RouteComponentProps<{ paymentId: string }> {
  paymentMethods: IMethod[];
}

class GPay extends PureComponent<IProps & IGooglePayConfigurationContext> {
  containerRef: RefObject<HTMLDivElement> = createRef();

  gpayPaymentMethodId = '';

  async componentDidMount() {
    const {
      paymentMethods,
      setHeight,
      setGooglePayConfiguration,
      googlePayConfiguration,
      match: {
        params: { paymentId },
      },
    } = this.props;
    setHeight(getContainerHeight(this.containerRef.current));
    this.gpayPaymentMethodId = paymentMethods[0].id;

    if (googlePayConfiguration === undefined || Object.keys(googlePayConfiguration).length === 0) {
      try {
        const configuration = (await getGooglePayConfiguration(
          paymentId,
          paymentMethods[0].pmpt
        )) as google.payments.api.PaymentDataRequest;
        setGooglePayConfiguration(configuration);
      } catch (error) {
        this.setState(() => {
          throw error;
        });
      }
    }
  }

  componentDidUpdate() {
    if (this.shouldRefreshState()) {
      const { setHeight } = this.props;
      setHeight(getContainerHeight(this.containerRef.current));
    }
  }

  shouldRefreshState() {
    const { paymentMethodId, progress } = this.props;

    return this.gpayPaymentMethodId === paymentMethodId && progress < PROGRESS.SELECT_GPAY_METHOD;
  }

  render() {
    return <GPayDetailsContainer className="google-pay__container" ref={this.containerRef} />;
  }
}

export default withContext(withTextContext(withGooglePayConfigurationContext(withRouter(GPay))));
